export default __webpack_public_path__ + "static/media/4-mobile+hor.4f9ebf90.jpg";